import { Box, Typography } from '@mui/material';
import { VariantType } from 'notistack';
import React from 'react';
import StyledBox from './styles';

function Progress(props: { duration: number, variant?: VariantType }) {
  const { duration, variant } = props;
  const [progress, setProgress] = React.useState(Math.floor(duration / 1000));
  React.useEffect(() => {
    const timerId = setInterval(() => {
      setProgress((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [progress]);

  return (
    <Box className={variant}>
      <Typography variant="h4">
        {progress}
        s
      </Typography>
    </Box>
  );
}

export default function ActivityChangeContent(props: {
  duration: number,
  title: string,
  body: string,
  variant: VariantType,
}) {
  const {
    duration, title, body, variant,
  } = props;
  return (
    <StyledBox>
      <Progress duration={duration} variant={variant} />
      <Typography variant="h6">
        {title}
      </Typography>
      <Typography variant="body1">
        {body}
      </Typography>
    </StyledBox>
  );
}
